<template>
  <div>
    <div class="d-flex align-items-center my-3 stage-header">
      <GoBackBtn history-mode />
      <Title :text="title" class="px-3" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Title from '@/components/atoms/Title';
import GoBackBtn from '@/components/common/GoBackBtn';

export default {
  name: 'PlayerStageWrapper',
  components: {
    Title,
    GoBackBtn,
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$t(this.$route.meta.titleKey, this.$route.meta.fallbackLabel);
    },
  },
};
</script>
